import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
  background: ${(props) => props.theme.base.background};
        
    ::-webkit-scrollbar {
      width: 8px;
      background-color: ${(props) => props.theme.base.card};
    }
        
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: ${(props) => props.theme.base.label};
    }
        
    scrollbar-width: thin;
    scrollbar-color: 
    ${(props) => props.theme.base.label} ${(props) => props.theme.base.card};
        
    scrollbar-base-color: ${(props) => props.theme.base.card};
    scrollbar-3dlight-color: ${(props) => props.theme.base.card};
    scrollbar-darkshadow-color: ${(props) => props.theme.base.card};
    scrollbar-highlight-color: ${(props) => props.theme.base.card};
    scrollbar-shadow-color: ${(props) => props.theme.base.card};
    scrollbar-arrow-color: ${(props) => props.theme.base.label};
  }


  body {
    color: ${(props) => props.theme.base.title};
    font-family: ${(props) => props.theme.font.main};
    font-size: ${(props) => props.theme.fontSize[16]};
    font-weight: ${(props) => props.theme.fontWeight[400]};
  }

  img,
  picture,
  svg {
    max-width: 100%;
    display: block;
  }
`;
